import styled, { Theme } from '../../constants/theme'

export const Badge = styled.span(
  ({ theme }: { theme: Theme }) => ({
    backgroundColor: theme.success,
    color: theme.text,
  }),
  {
    alignItems: 'center',
    borderRadius: 9,
    display: 'flex',
    fontSize: 8,
    fontWeight: 'bold',
    height: 17,
    justifyContent: 'center',
    lineHeight: 'normal',
    width: 30,
  },
)

export const PhrasesBadge = styled(Badge)(({ theme }: { theme: Theme }) => ({
  '&.My': {
    backgroundColor: theme.provider.darkBlue,
    color: theme.textLight,
    width: 24,
  },
  '&.Shared': {
    backgroundColor: theme.provider.green,
    color: theme.textLight,
    width: 38,
  },
}))
